module.exports = __webpack_public_path__ + "img/20.ab3498e7.jpg";